import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { TAGS, API_PATH } from '../constants'

const deleteTag = async (id: number) => {
  await fetchAPI({
    path: `${API_PATH}/${id}`,
    method: 'delete',
  })
}

export const useDeleteTag = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteTag, {
    async onSuccess() {
      await queryClient.refetchQueries([TAGS])

      toast({
        description: t('views.admin.campaigns.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
